module.exports = __webpack_public_path__ + "static/media/2025-AFL-Footy-Lives-Here-Desktop-Banner-@1x.47f4a485.jpg";